// API Servers
export const API_SERVER = {
  LOCAL: "http://localhost:8000",
  DEV: "https://aks-d1-app-mpstr-dev.musea2.azure.ext.gm.com",
  PROD: "https://aks-p1-app-mpstr.musea2.azure.ext.gm.com",
};

// App Environment
export const APP_ENV = {
  LOCAL: ["local", "q1"],
  DEV: "dev",
  PROD: "prod",
};

// GM Proxy
export const GM_PROXY = "http://dcproxy.gm.com:8080";

// Authenticated token route
export const AUTH_TOKEN_ROUTES = {
  LOCAL: "http://localhost:5006/api/token",
  REMOTE: "/api/token",
};

// Allowed Hosts
export const ALLOWED_HOSTS = [
  "localhost",
  "aks-d1-app-mpstr-dev.musea2.azure.ext.gm.com",
  "mpstr-dev.gm.com",
  "aks-p1-app-mpstr.musea2.azure.ext.gm.com",
];

// Microsoft authentication config
export const MSAL_CONFIG = {
  CLIENT_ID: process.env.REACT_APP_UI_CLIENT_ID,
  AUTHORITY: `https://login.microsoftonline.com/${process.env.REACT_APP_UI_TENANT_ID}`,
};

// map layer config
export const MAP_LAYER_CONFIG = {
  TYPE: "circle",
  STYLE: "mapbox://styles/mapbox/satellite-streets-v12",
  TOKEN: process.env.REACT_APP_MAPBOX_TOKEN,
  PAINT: {
    "circle-opacity": 0.5,
    "circle-radius": {
      stops: [
        [19, 5],
        [21, 20],
      ],
    },
    "circle-color": "#0033ff",
  },
};

// Supported servers
export const SERVERS = {
  S3_SERVER: "s3_dev",
  ADLS_SERVER: "adls_124381d1stadls",
  UC_SERVER: "unity_catalog_124381d1",
};

// Data sources
export const DATA_SOURCES = {
  S3: "S3",
  ADLS: "ADLS",
  UNITY_CATALOG: "Unity Catalog",
};

// Endpoint data types
export const ENDPOINT_DATA_TYPES = {
  UNSTRUCTURED: "Unstructured",
  USMS: "USMS",
};

// Default values
export const DEFAULT_VALUES = {
  s3DefaultAccount: "avmms",
  s3DefaultBucket: "mapster-dev",
  unstucturedS3DefaultFilePath:
    "2024-07/map-new-mcis-map/3119093/ora0c/eom/dpsd3/LaneSegmentGeometry.parquet",
  unstructuredUCDefaultCatalog: "uc_mapping_dev",
  unstructuredUCDefaultSchema: "map_data_testing",
  unstructuredUCDefaultTable: "mapster_test_vertex_table",
  unstructuredUCDefaultDiffCol: "",
  unstructuredUCDefaultDiffVal: "",
  defaultGeometryCol: "",
  unstructuredADLSDefaultContainer: "hpc-offline-data",
  unstructuredADLSDefaultFilePath:
    "cloud_point_to_geometry/dmp_common_edge_img.parquet",
  usmsDefaultFilePath: "2024-07/map-new-mcis-map/3187636/5odh9/",
  usmsDefaultFeature: "eom",
  usmsDefaultLayer: "LaneSegmentGeometry.parquet",
};

// Layer templet
export const LAYER_TEMPLET = {
  id: null,
  name: null,
  color: null,
  dataEndpoint: null,
  dataSource: null,
  serverInput: null,
  s3Account: null,
  s3Bucket: null,
  s3FilePath: null,
  adlsContainer: null,
  adlsFilepath: null,
  unityCatalogCatalog: null,
  unityCatalogSchema: null,
  unityCatalogTable: null,
  unityCatalogDiffCol: null,
  unityCatalogDiffVal: null,
  usmsFilePath: null,
  usmsFeature: null,
  usmsLayer: null,
  geometryCol: null,
  isNewLayer: true,
};

// Alert messages config
export const ALERT_MESSAGE = {
  TIMER: 5000,
  DEFAULT_DETAIL: "Something went wrong. Please contact the admin!",
  STATUS_MAP: {
    400: "Bad Request",
    401: "Unauthorized",
    403: "Forbidden",
    422: "Unprocessable Entity",
    404: "Not Found",
    500: "Internal Server Error",
    502: "Bad Gateway",
    503: "Service Unavailable",
    504: "Gateway Timeout",
  },
  UNKNOW_ERROR_STATUS: "Unknown Error occurred",
  ERROR: {
    SEVERITY: "error",
    TITLE: "Error"
  },
  WARNING: {
    SEVERITY: "warning",
    TITLE: "Warning",
  },
  INFO: {
    SEVERITY: "info",
    TITLE: "Info",
  },
  SUCCESS: {
    SEVERITY: "success",
    TITLE: "Success",
  },
  MAX_ALERTS: 3,
};
